<template>
<div class="champion-wrap">
    <h2 class="champion-label">世界選手権チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('70')"><span class="history__head--circle">1977-1978</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">1977年<span class="year-title__sub">昭和52年</span></h2>
                <ul>
                    <li>片山敬済／ロードレース・350ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1978年<span class="year-title__sub">昭和53年</span></h2>
                <ul>
                    <li>渡辺 明／モトクロス・125ccクラス</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1993-1998</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>原田哲也／ロードレース・250ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>坂田和人／ロードレース・125ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>青木治親／ロードレース・125ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>青木治親／ロードレース・125ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>坂田和人／ロードレース・125ccクラス</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2008</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>加藤大治郎／ロードレース・250ccクラス</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>野崎史高／トライアル・Jr TRCUP</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>藤波貴久／トライアル・世界選手権</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>北川圭一／ロードレース・耐久選手権</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>北川圭一／ロードレース・耐久選手権</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>青山博一／ロードレース・250ccクラス</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2021</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>酒井大作／ロードレース・耐久選手権</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>TSR／ロードレース・耐久選手権</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>2021年ヨシムラ SERT Motul／ロードレース・耐久選手権</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['100']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>